import { getConfigBaseUrl } from '../../services/apiService';
import { apiCall, createApiThunk } from '../../utils/api';

export const getAllLayoutThunk = createApiThunk('GET_ALL_LAYOUT', apiCall);
export const createNewLayoutThunk = createApiThunk('CREATE_NEW_LAYOUT', apiCall);
export const updateExistingLayoutThunk = createApiThunk('UPDATE_NEW_LAYOUT', apiCall);

export const getAllLayoutByScreenId = (screenId) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/${screenId}`;
  return dispatch(getAllLayoutThunk({ url, method: 'GET' }));
};

export const createNewLayout = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/`;
  return dispatch(createNewLayoutThunk({ url, method: 'POST', data }));
};

export const updateExistingLayout = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/`;
  return dispatch(updateExistingLayoutThunk({ url, method: 'PUT', data }));
};

// export const deleteDataVisualizationDetails = (screenId) => (dispatch: any) => {
//   return dispatch(
//     del(
//       DELETE_DATAVISUALIZATION_DETAILS_NEW,
//       `${getConfigBaseUrl()}/v2/config/users/layouts/${screenId}`,
//     ),
//   );
// };
